import { useQuery } from "@tanstack/react-query";

import { getDiagnostic } from "@/api/diagnostic";

export const diagnosticKeys = {
  snapshot: (projectId: string) => ["diagnostic", projectId] as const,
};

/**
 * Único ponto de rede da tela de Diagnóstico — só `ProjectDiagnostic` chama.
 * As abas recebem `sections` por props, o que as mantém testáveis sem mock.
 */
export function useDiagnostic(projectId: string | undefined) {
  return useQuery({
    queryKey: diagnosticKeys.snapshot(projectId ?? ""),
    queryFn: () => getDiagnostic(projectId!),
    enabled: !!projectId,
    staleTime: 30_000,
  });
}
